import { RegularManualRosteringRouting, RegularManualRosteringRoutingBroudcrumbs } from "./regular-manual-rostering/regular-manual-rostering.routing";
import { TemporaryManualRosteringComponent } from "./temporary-manual-rostering/temporary-manual-rostering.component";
//import { TemporaryManualRosteringRouting } from "./temporary-manual-rostering/temporary-manual-rostering.routing";

export const ManualRosteringRouting = [
    { path: 'regular', children: RegularManualRosteringRouting },
    //{ path: 'temporary', children: TemporaryManualRosteringRouting },
    { path: 'temporary', component: TemporaryManualRosteringComponent },
];

// export const ManualRosteringRoutingBreadcrumbs = [
//     { name: 'regular', path: '/regular', children: RegularManualRosteringRoutingBroudcrumbs },
//     { name: 'Temporary', path: '/temporary' },
// ]